<template>
  <div class="filter-mobile">
    <div class="filter-mobile__label display-flex-center justify-content-between">
      <div
        class="item btn btn-gray border-rd-20 display-flex-center justify-content-center"
        :class="{'active': selectBoxOpen === 'class'}"
        @click="handleCollapseSelect('class')"
      >
        <span
          class="item__name font-sanpro-semibold font-size-16"
          :class="{'primary-color': selectBoxOpen === 'class', 'secondary-color-txt': selectBoxOpen !== 'class'}"
        >
          {{ classes[classIndexActive].name }}
        </span>
        <span class="item__icon">
          <i
            class="icon-arrow-down font-size-12"
            :class="{'primary-color': selectBoxOpen === 'class', 'secondary-color-txt': selectBoxOpen !== 'class'}"
          ></i>
        </span>
      </div>
      <div
        v-if="bookGroups && bookGroups.length > 0"
        class="item btn btn-gray border-rd-20 display-flex-center justify-content-center"
        :class="{'active': selectBoxOpen === 'group'}"
        @click="handleCollapseSelect('group')"
      >
        <span
          class="item__name font-sanpro-semibold font-size-16"
          :class="{'primary-color': selectBoxOpen === 'group', 'secondary-color-txt': selectBoxOpen !== 'group'}"
        >
          Bộ sách
        </span>
        <span class="item__icon">
          <i
            class="icon-arrow-down font-size-12"
            :class="{'primary-color': selectBoxOpen === 'group', 'secondary-color-txt': selectBoxOpen !== 'group'}"
          ></i>
        </span>
      </div>
    </div>
    <div class="filter-mobile__body">
      <div v-if="selectBoxOpen === 'class'" class="filter-mobile__class display-flex-wrap justify-content-between">
        <a
          v-for="(item, index) of classes"
          :key="index"
          href="javascript:;"
          class="item btn btn-gray border-rd-20 font-sanpro-semibold font-size-15"
          :class="{'active primary-color': selectClass === item.classId, 'secondary-color-txt': selectClass !== item.classId}"
          @click="handleFilterByClass(item)"
        >
          {{ item.classNo }}
        </a>
      </div>
      <div v-else-if="selectBoxOpen === 'group'" class="filter-mobile__group display-flex-wrap justify-content-between">
        <a
          v-for="(item, index) of bookGroups"
          :key="index"
          href="javascript:;"
          class="item btn btn-gray border-rd-20 font-sanpro-semibold font-size-15"
          :class="{'active primary-color': bookGroupActive === item.practiceTypeId, 'secondary-color-txt': bookGroupActive !== item.practiceTypeId}"
          @click="handleFilterByGroup(item)"
        >
          {{ item.name }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FilterMobile',
  props: {
    selectClass: Number,
    classes: Array,
    bookGroups: Array
  },
  data() {
    return {
      selectBoxOpen: '' // class, group
    };
  },
  computed: {
    classId () {
      return parseInt(this.$route.query.lop)
    },
    classIndexActive () {
      let result = 0
      if (this.$route.query.lop) {
        result = this.classes.findIndex(cl => cl.classId === parseInt(this.$route.query.lop))
      }
      return result
    },
    bookGroupActive () {
      return parseInt(this.$route.query.tab) || 0
    }
  },
  methods: {

    handleCollapseSelect (type) {
      this.selectBoxOpen = this.selectBoxOpen === type ? '' : type
    },

    handleFilterByClass (data) {
      this.classId !== data.classId && this.$emit('filterClass', data)
    },

    handleFilterByGroup (index) {
      if (this.bookGroupActive !== index) {
        this.$emit('filterGroup', index)
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.filter-mobile {
  &__label {
    .item {
      width: 49%;
    }
  }
}
</style>
